/*
 * GameState.ts
 */
export class GameState {
    constructor(type) {
        this.type = type;
    }
    static getState(state) {
        return GameState[state];
    }
    isPurchaseEntry() {
        return this == GameState.PURCHASE_ENTRY;
    }
    isReplayPurchaseEntry() {
        return this == GameState.REPLAY_PURCHASE_ENTRY;
    }
    isStandardSpin() {
        return this == GameState.STANDARD_SPIN;
    }
    isFreeSpin() {
        return this == GameState.FREE_SPIN;
    }
    isPurchaseSpin() {
        return this == GameState.PURCHASE_SPIN;
    }
    isChooseCell() {
        return this == GameState.CHOOSE_CELL;
    }
    isComplete() {
        return this == GameState.COMPLETE;
    }
    isReplayStandardSpin() {
        return this == GameState.REPLAY_STANDARD_SPIN;
    }
    isReplayFreeSpin() {
        return this == GameState.REPLAY_FREE_SPIN;
    }
    isReplayPurchaseSpin() {
        return this == GameState.REPLAY_PURCHASE_SPIN;
    }
    isReplay() {
        return this == GameState.REPLAY;
    }
    isSpin() {
        return this.isStandardSpin() || this.isFreeSpin() || this.isPurchaseSpin() || this.isReplayStandardSpin() || this.isReplayFreeSpin() || this.isReplayPurchaseSpin();
    }
    getType() {
        return this.type;
    }
}
GameState.PURCHASE_ENTRY = new GameState("PURCHASE_ENTRY");
GameState.STANDARD_SPIN = new GameState("STANDARD_SPIN");
GameState.FREE_SPIN = new GameState("FREE_SPIN");
GameState.PURCHASE_SPIN = new GameState("PURCHASE_SPIN");
GameState.CHOOSE_CELL = new GameState("CHOOSE_CELL");
GameState.COMPLETE = new GameState("COMPLETE");
GameState.REPLAY_PURCHASE_ENTRY = new GameState("REPLAY_PURCHASE_ENTRY");
GameState.REPLAY_STANDARD_SPIN = new GameState("REPLAY_STANDARD_SPIN");
GameState.REPLAY_FREE_SPIN = new GameState("REPLAY_FREE_SPIN");
GameState.REPLAY_PURCHASE_SPIN = new GameState("REPLAY_PURCHASE_SPIN");
GameState.REPLAY_CHOOSE_CELL = new GameState("REPLAY_CHOOSE_CELL");
GameState.REPLAY = new GameState("REPLAY");
//# sourceMappingURL=GameState.js.map